function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Plane") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Plane"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.1064,374.737A310.6006,310.6006,0,0,0,231.82,342.01l1.9086,89.7113a40.3426,40.3426,0,0,1-11.8069,29.3846L202.0269,481l-58.8543-98.09Z",
    style: {
      fill: "#0d8dce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.2634,345.8939a310.6006,310.6006,0,0,1,32.7271-65.7134l-89.7113-1.9086a40.3427,40.3427,0,0,0-29.3846,11.807L31,309.9735l98.09,58.8542Z",
    style: {
      fill: "#289fe8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1519,466.1554,288.1334,295.1277,387.9,195.3615l39.1137,221.6448a40.2637,40.2637,0,0,1-11.18,35.4679Z",
    style: {
      fill: "#0d8dce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8449,109.8485,216.8727,223.867l99.7661-99.7662L94.994,84.987a40.2636,40.2636,0,0,0-35.4679,11.18Z",
    style: {
      fill: "#289fe8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.7693,77.4219a74.0834,74.0834,0,0,1-25.3269-16.8646L130.7654,381.2342a9.9255,9.9255,0,0,0,10.9563,2.193l24.3857-8.6893a310.6921,310.6921,0,0,0,115.3885-72.9692L439.0012,144.2635a142.6567,142.6567,0,0,0,36.2919-61.6719Z",
    style: {
      fill: "#f4dec6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5787,35.2312,429.41,36.7083a142.6575,142.6575,0,0,0-61.6736,36.29L210.2309,230.5037a310.6959,310.6959,0,0,0-72.9674,115.39l-8.6911,24.384a9.928,9.928,0,0,0,2.193,10.9562L451.4424,60.5573A74.08,74.08,0,0,1,434.5787,35.2312Z",
    style: {
      fill: "#ffefdc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5131,395.4866a10.0786,10.0786,0,0,0,14.2523,0L230.5316,295.72a10.0784,10.0784,0,0,0,0-14.2523Z",
    style: {
      fill: "#0d8dce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5316,281.4681a10.0784,10.0784,0,0,0-14.2523,0l-99.7662,99.7661a10.0785,10.0785,0,0,0,0,14.2524Z",
    style: {
      fill: "#289fe8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.979,80.02a42.8034,42.8034,0,0,1,12.6166,30.4637,10.9181,10.9181,0,0,1-21.8362,0,21.2059,21.2059,0,0,0-6.366-14.8781Z",
    style: {
      fill: "#36546b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9774,80.0184a42.8033,42.8033,0,0,0-30.4637-12.6166,10.9181,10.9181,0,1,0,0,21.8362,21.2054,21.2054,0,0,1,14.8781,6.3661Z",
    style: {
      fill: "#45617f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.8209,39.1788,451.4424,60.5573a74.0834,74.0834,0,0,0,25.3269,16.8646l3.1273-10.9442A27.5294,27.5294,0,0,0,472.8209,39.1788Z",
    style: {
      fill: "#0d8dce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.8209,39.1788a27.5293,27.5293,0,0,0-27.299-7.0757l-10.9432,3.1281a74.08,74.08,0,0,0,16.8637,25.3261Z",
    style: {
      fill: "#289fe8"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.36b1db2932ddf74089cd16f7fa398f5f.svg";
export { ForwardRef as ReactComponent };